export default "__VITE_ASSET__BldZ5xwS__"